/** Stable id for the root shell route (`useRouteLoaderData`, tests). */
export const ROOT_SHELL_ROUTE_ID = "root-shell";
